import { Box, Button, Flex, Textarea } from "@chakra-ui/react";
import React from "react";
import { MdOutlineSaveAlt } from "react-icons/md";

export const ModalObservacao = (dados) => {
  return (
    <Box mt="1rem" w="100%">
      <Textarea w='99.3%' placeholder="Observações..." focusBorderColor="#03a9f4" autoFocus/>
      <Flex
      w='99.3%'
      justify="right"
      >

        {!dados.visualizar ? 
          <Button
            mt='0.5rem'
            color="#03a9f4"
            borderColor="#03a9f4"
            _hover={{ bgColor: "#d6eef7" }}
            _active={{ bgColor: "white" }}
            variant='outline'
            boxShadow="none !important"
            leftIcon={<MdOutlineSaveAlt color="#03a9f4" size="25px" />}
          >
            Salvar
          </Button> :
          <></>
        }
        
      </Flex>
    </Box>
  );
};
